import {
  IUpsellingServiceItem,
  IUpsellingVenueItem,
} from "../types/upsell.types";
import { ILeadUpsellWithCount } from "../types/upsellLeads.types";

export const extractUniqueUpsellData = (
  leadsData: any[]
): ILeadUpsellWithCount[] => {
  if (!leadsData || leadsData.length === 0) {
    return [];
  }

  const upsellMap = new Map<string, ILeadUpsellWithCount>();

  leadsData.forEach((lead) => {
    const upsellingServices = lead.upselling_services;

    if (Array.isArray(upsellingServices) && upsellingServices.length > 0) {
      upsellingServices.forEach((serviceItem: IUpsellingServiceItem) => {
        if (serviceItem && serviceItem.service_item_uuid) {
          const upsellKey = serviceItem.service_item_uuid;

          if (upsellMap.has(upsellKey)) {
            // Increment lead count for existing upsell
            const existingUpsell = upsellMap.get(upsellKey)!;
            existingUpsell.lead_count = (existingUpsell.lead_count || 0) + 1;
          } else {
            // Add new upsell with lead_count = 1
            upsellMap.set(upsellKey, {
              ...serviceItem,
              lead_count: 1,
            });
          }
        }
      });
    }
  });

  return Array.from(upsellMap.values()).sort(
    (a, b) => (b.lead_count || 0) - (a.lead_count || 0)
  );
};

export const getAllUpsellData = (leadsData: any[]): IUpsellingServiceItem[] => {
  if (!leadsData || leadsData.length === 0) {
    return [];
  }

  const allUpsells: IUpsellingServiceItem[] = [];

  leadsData.forEach((lead) => {
    // upselling_services is an array inside each lead
    if (Array.isArray(lead.upselling_services)) {
      allUpsells.push(...lead.upselling_services);
    }
  });

  return allUpsells;
};

export const getUpsellDataByCategory = (
  leadsData: any[]
): Record<string, IUpsellingServiceItem[]> => {
  if (!leadsData || leadsData.length === 0) {
    return {};
  }

  const categoryMap: Record<string, IUpsellingServiceItem[]> = {};

  leadsData.forEach((lead) => {
    // upselling_services is an array inside each lead
    if (Array.isArray(lead.upselling_services)) {
      lead.upselling_services.forEach((serviceItem: IUpsellingServiceItem) => {
        if (serviceItem && serviceItem.service_category_name) {
          const categoryName = serviceItem.service_category_name;

          if (!categoryMap[categoryName]) {
            categoryMap[categoryName] = [];
          }

          categoryMap[categoryName].push(serviceItem);
        }
      });
    }
  });

  return categoryMap;
};

export const calculateUpsellRevenue = (
  upsellData: ILeadUpsellWithCount
): number => {
  if (!upsellData.variant || upsellData.variant.length === 0) {
    return 0;
  }

  const maxPrice = Math.max(...upsellData.variant.map((v) => v.price));
  return maxPrice * (upsellData.lead_count || 1);
};

export const extractVenueUpsellInfo = (
  leadsData: any[]
): IUpsellingVenueItem | null => {
  if (!leadsData || leadsData.length === 0) {
    return null;
  }

  for (const lead of leadsData) {
    if (lead.upselling_venue) {
      return lead.upselling_venue;
    }
  }

  return null;
};
